<template>
  <div>
    <div>
      <span v-html="formattedNumber"/>
      <v-icon v-if="value.icon"
              :color="value.icon.color"
              class="ml-2">
        {{ value.icon.name }}
      </v-icon>
    </div>

    <div v-if="value.date && withDate"
         class="date">
      <fin-time-ago :datetime="value.date" :prependText="value.datePrefix" :limit="msOneDay"/>
    </div>

    <div v-if="value.hint"
         class="hint">
      {{ value.hint }}
    </div>
  </div>
</template>

<script>
//TODO configurable currency path
export default {
  name: "InstrumentCurrencyCell",
  props: {
    value: {},
    item: {},
    header: {}
  },
  data() {
    return {
      msOneDay: 1000 * 60 * 60 * 24
    }
  },
  computed: {
    withDate() {
      return !this.header.componentProps?.withoutDate
    },
    formattedNumber() {
      let number = this.value
      if (this.value instanceof Object) {
        number = this.value.value
      }
      if (!number) {
        return '&dash;'
      }
      return this.$options.filters['numberFormattedShort'](number) + '&nbsp;' + '€'
      /*(this.$options.methods.getSymbolFromCurrency(this.item.currency) */
    }
  }
}
</script>

<style lang="scss" scoped>
.date {
  font-size: 12px;
  color: #99a0a4;
}

.hint {
  color: $fin-color-accent-gray;
  font-size: 12px;
}
</style>
